// extracted by mini-css-extract-plugin
export default {"customFormGroup":"styles_customFormGroup__XkBTR","dropAreaWrap":"styles_dropAreaWrap__bmbwd"};